export default __webpack_public_path__ + "static/media/tabkhir.fc4823ee.png";